import { render, staticRenderFns } from "./DisableCreateOrders.vue?vue&type=template&id=131ab799&scoped=true&"
import script from "./DisableCreateOrders.vue?vue&type=script&lang=js&"
export * from "./DisableCreateOrders.vue?vue&type=script&lang=js&"
import style0 from "./DisableCreateOrders.vue?vue&type=style&index=0&id=131ab799&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131ab799",
  null
  
)

export default component.exports